import { AttributesMixin, define, Model } from "@type-r/models";
import { restfulIO } from "./endpoint";
import { PurchaseOrder } from "./purchaseOrder";

export interface ManualPurchaseOrder extends AttributesMixin<typeof ManualPurchaseOrder> { }
@define
export class ManualPurchaseOrder extends Model {
  static endpoint = restfulIO('api/v1/ingest/purchaseOrders');

  static attributes = {
    id: String,
    status: String,
    ...PurchaseOrder.attributes
  }
}
